import React from 'react';
import type { MarketGroupingMode } from '../../utils/marketGroupUtils';

type MarketDashboardGroupingSwitchProps = {
  mode: MarketGroupingMode;
  onChange: (mode: MarketGroupingMode) => void;
  disabled?: boolean;
};

const MarketDashboardGroupingSwitch: React.FC<MarketDashboardGroupingSwitchProps> = ({
  mode,
  onChange,
  disabled = false,
}) => (
  <div
    className="market-filter-mode-switch"
    role="group"
    aria-label="Грейд / Карьерный уровень"
    style={disabled ? { opacity: 0.55, pointerEvents: 'none' } : undefined}
  >
    <button
      type="button"
      className={`market-filter-mode-btn ${mode === 'grade' ? 'active' : ''}`}
      onClick={() => onChange('grade')}
      disabled={disabled}
    >
      Грейд
    </button>
    <button
      type="button"
      className={`market-filter-mode-btn ${mode === 'cluster' ? 'active' : ''}`}
      onClick={() => onChange('cluster')}
      disabled={disabled}
    >
      Карьерный уровень
    </button>
  </div>
);

export default MarketDashboardGroupingSwitch;
